import React from 'react';

interface VideoProps {
    src: string;
}

const Video: React.FC<VideoProps> = ({ src }) => {
    return (
        <video className="a-video loading-bg" loop muted controls autoPlay>
            <source src={src} type="video/mp4" />
            Your browser does not support the video tag.
        </video>
    );
};

export default Video;